import CheckboxInput from 'Components/Form/Inputs/CheckboxInput';
import { FilterGroup } from './FilterGroup';

export function MultiCheckboxGroup<
  T extends string | number,
  Name extends string,
>({
  options,
  name,
  checked,
  label,
  onChange,
  onUpdateField,
}: {
  checked?: T[];
  label: string;
  name: Name;
  options: { label: string; value: T }[];
  onChange?: (checked: T[]) => void;
  onUpdateField?: (name: Name, checked: T[]) => void;
}) {
  const onClear = () => {
    onChange && onChange([]);
    onUpdateField && onUpdateField(name, []);
  };

  return (
    <FilterGroup
      onClear={onClear}
      isDirty={!!checked && checked.length > 0}
      label={label}
      uuid={name}
    >
      {options.map((checkbox) => (
        <CheckboxInput
          key={checkbox.value}
          name={checkbox.value}
          label={checkbox.label}
          checked={(checked || []).includes(checkbox.value)}
          onChange={(isChecked) => {
            const state = isChecked
              ? (checked || []).concat(checkbox.value)
              : (checked || []).filter((_) => _ !== checkbox.value);

            onChange && onChange(state);
            onUpdateField && onUpdateField(name, state);
          }}
        />
      ))}
    </FilterGroup>
  );
}
